import React, { FC, useState } from 'react';
import {
  UserState,
  SessionState,
  SessionType,
  UserType,
  LoginForm,
  AuthStore,
  LoadingAnimation,
  useShowAlertPopup,
} from '@dew21/ui';
import axios from 'axios';
import { useSetRecoilState } from 'recoil';
import { useHistory } from 'react-router';
import { APP_PORTAL_NAME } from '../general/RouterView';

export const LoginRoute: FC = (props) => {
  const history = useHistory();

  const setUser = useSetRecoilState<UserType>(UserState);
  const setSession = useSetRecoilState<SessionType>(SessionState);
  const [loading, setLoading] = useState(false);
  const showNotificationBanner = useShowAlertPopup();

  return (
    <>
      {
        loading &&
        <LoadingAnimation overlay/>
      }
      <LoginForm
        appName={APP_PORTAL_NAME}
        onLoginClick={(headers) => {
          setLoading(true);
          axios.post('/api/auth/login/admin', {}, { headers }).then((response) => {
            setLoading(false);

            AuthStore.setSession(response.data);
            const { tokens, ...user } = response.data;
            setSession({ current: { tokens } });
            setUser({ current: user });

            history.push('/');
          }).catch((error) => {
            setLoading(false);
            // console.log(error);
            setUser({ current: null });
            setSession({ current: null });
            showNotificationBanner({
              error: true,
              renderContent: () => {
                return <>Sie konnten nicht angemeldet werden. Entweder Ihr Benutzername oder Passwort ist falsch oder Sie sind nicht berechtigt, die Administration zu nutzen.</>
              }
            })
          });
        }}
        onForgotPasswordClick={(email: string | null) => {
          if (email?.includes('@')) {
            axios.post('/api/auth/password/request', { email: email?.toLowerCase() })
              .then(() => {
                showNotificationBanner({
                  error: false,
                  renderContent: () => {
                    return <>Eine E-Mail mit Instruktion zum zurücksetzen Ihres Passwords wurde an {email} versand.</>;
                  },
                });
              }).catch((e) => {
                console.log(e);
              showNotificationBanner({
                error: true,
                renderContent: () => {
                  return <>Da ist etwas schief gelaufen. Bitte versuchen Sie es in 15 Minuten erneut.</>;
                },
              });
            })
          } else {
            showNotificationBanner({
              error: true,
              renderContent: () => {
                return <>Bitte geben Sie eine gültige E-Mail Adresse an!</>;
              },
            });
          }
        }}
      />
    </>
  );
};
